module.exports = __webpack_public_path__ + "static/media/EmilyKellyHS_1588952498046.4e75c7d9.jpg";